/* RESPONSIBLE TEAM: team-standalone */

import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default class ZendeskConfigurationSerializer extends EmbercomBaseSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    sunshineIntegration: { embedded: 'always' },
    ticketsIntegration: { embedded: 'always' },
  };
}
